import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { useGetBandshopProductsQuery } from 'services/apiConteudo';

import SectionHorizontalSkeleton from '../components/SectionHorizontalSkeleton';
import SectionBandshop from './SectionBandshop';

import ChevronDown from 'components/Icons/ChevronDown';
import ChevronUp from 'components/Icons/ChevronUp';
import CartIcon from 'components/Icons/bandshop/Cart';
import { useProgram } from 'components/Program/context';

type AcordionProps = {
  collectionId: number;
};

const AccordionBandshop = ({ collectionId }: AcordionProps) => {
  const [expanded, setExpanded] = useState(true);
  const [timeoutReached, setTimeoutReached] = useState(false);
  const program = useProgram();
  const analytics = useAnalytics();
  const { data, error, isLoading: isFetchingData } = useGetBandshopProductsQuery({ collectionId });

  const productItems = data?.data?.bandshop;

  const toggleExpand = () => {
    analytics.triggerAccordionBandshopActionEvent({
      isExpanded: !expanded,
      programId: program?._id,
      programTitle: program?.title,
      programAgeRating: program?.rating,
    });

    setExpanded(!expanded);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimeoutReached(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  useFocusEffect(
    useCallback(() => {
      analytics.triggerAccordionBandshopViewEvent({
        isExpanded: expanded,
        collectionId,
        programId: program?._id,
        programTitle: program?.title,
        programAgeRating: program?.rating,
      });
    }, [])
  );

  if (isFetchingData && !timeoutReached) {
    return (
      <View style={{ marginBottom: 50 }}>
        <View
          style={{
            width: '100%',
            height: 40,
            backgroundColor: 'rgba(0, 8, 117, 0.3)',
            marginBottom: 4,
          }}
        />
        <View
          style={{
            padding: 21,
            borderWidth: 2,
            borderColor: '#001075',
            borderRadius: 8,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            backgroundColor: 'rgba(0, 16, 117, 0.5)',
          }}>
          <SectionHorizontalSkeleton
            _name="section"
            title="Ofertas Bandshop"
            variant="section.bandshop"
          />
        </View>
      </View>
    );
  }

  if (
    error ||
    (isFetchingData && timeoutReached) ||
    ((!productItems || productItems.length === 0) && !isFetchingData)
  )
    return null;

  return (
    <View style={{ overflow: 'hidden' }}>
      <Pressable
        onPress={toggleExpand}
        style={{
          paddingTop: 14,
          paddingBottom: 14,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <CartIcon width={20} height={20} style={{ marginRight: 8 }} hasNotification={!expanded} />
          <Text
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              color: '#fff',
            }}>
            Ofertas Bandshop
          </Text>
        </View>

        {expanded ? <ChevronUp width={20} height={20} /> : <ChevronDown width={20} height={20} />}
      </Pressable>
      {expanded ? (
        <View
          style={{
            padding: 21,
            borderWidth: 2,
            borderColor: '#001075',
            borderRadius: 8,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            backgroundColor: 'rgba(0, 16, 117, 0.5)',
          }}>
          <SectionBandshop items={productItems} />
        </View>
      ) : (
        <View style={{ width: '100%', backgroundColor: '#001075', height: 2 }} />
      )}
    </View>
  );
};

export default AccordionBandshop;
